<template>
    <div id="app">
        <header>
            <div class="tw-container tw-py-1 lg:tw-py-3 tw-flex tw-items-center tw-justify-center">
                <img src="~@/assets/img/logo.svg" class="tw-pointer-events-none">
            </div>
        </header>

        <!-- This will be reaplced by the view defined in the router -->
        <router-view></router-view>

        <footer v-scroll-to="'form'">
            <div class="tw-container tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8 lg:tw-py-10">
                <img src="~@/assets/img/logo.svg" class="tw-pb-3 tw-pointer-events-none">
                <small class="tw-text-center tw-block tw-text-xs">* Offre valable du 22/06 au 30/09/22 sur le produit de votre choix. Hors promotions et commandes en cours, hors prix rouges, hors prestations, hors accessoires et consommables. Non cumulable.</small>
                <small class="tw-text-center tw-block tw-text-xs tw-pb-3">** Poseurs salariés et artisans</small>
                <small class="tw-block tw-text-xs tw-pb-3">©{{new Date().getFullYear()}} St Maclou</small>
            </div>
        </footer>

        <ModalContainer>
            <Terms/>
        </ModalContainer>

        <Clarity/>

        <KwPixel v-if="$store.state.formSuccess"/>
    </div>
</template>

<script>
import axios from 'axios';
import KwPixel from '@/components/KwPixel.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';
import Clarity from '@/components/Clarity.vue';

export default {
    components: {
        KwPixel,
        Clarity,
        ModalContainer,
        Terms,
    },
    created() {
        const data = {
            url: window.location.hostname,
            pubid: this.$route.query.pubid || null,
            utm_source: this.$route.query.utm_source || null,
            utm_campaign: this.$route.query.utm_campaign || null,
            utm_medium: this.$route.query.utm_medium || null,
            utm_content: this.$route.query.utm_content || null,
            utm_term: this.$route.query.utm_term || null,
        };
        axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
            .then((response) => {
                this.$store.state.token = response.data.token;
            })
            .catch((error) => {
                console.log(error.response.data);
            });
    },
    mounted() {
        window.cmp_setlang = document.documentElement.lang;
    },
};
</script>
<style>

</style>
